import CallHelperService from '../../service/callHelper';
import ReduxUser from "./auth/user";

const Action = {
    GET_MEDICAL: "[ CALL_HELPER ] GET_MEDICAL",
    GET_MEDICALS: "[ CALL_HELPER ] GET_MEDICALS",
    UPDATE_MEDICAL:"[ CALL_HELPER ] UPDATE_MEDICAL",
};

const ActionCreator = {
    getMedical(medicalId) {
        return async (dispatch) => {
            try {
                const medical = await CallHelperService.medical.findById(medicalId);
                dispatch({type: Action.GET_MEDICAL, medical});
                return medical;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    getMedicals() {
        return async (dispatch) => {
            try {
                const medicals = await CallHelperService.medical.list();
                dispatch({type: Action.GET_MEDICALS, medicals});
                return medicals;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    setMedicalRole({medicalId, role}) {
        return async (dispatch) => {
            try {
                await CallHelperService.medical.setMedicalRole({medicalId, role});
                return dispatch(await ActionCreator.getMedical(medicalId));
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    updateMedical({medical}) {
        return async (dispatch) => {
            try {
                const updatedMedical = await CallHelperService.medical.updateMedical({medical});
                dispatch({type: Action.UPDATE_MEDICAL, updatedMedical});
                return updatedMedical;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    setMedicalLevel({medicalId, level}) {
        return async (dispatch) => {
            try {
                await CallHelperService.medical.setMedicalLevel({medicalId, level});
                return dispatch(await ActionCreator.getMedical(medicalId));
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    validateMedical({medicalId, institution, validateFail}) {
        return async (dispatch) => {
            try {
                await CallHelperService.medical.validate({medicalId, institution, validateFail});
                return dispatch(await ActionCreator.getMedical(medicalId));
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    enableMedical(medicalId) {
        return async (dispatch) => {
            try {
                await CallHelperService.medical.enable(medicalId);
                return dispatch(await ActionCreator.getMedical(medicalId));
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    disableMedical(medicalId) {
        return async (dispatch) => {
            try {
                await CallHelperService.medical.disable(medicalId);
                return dispatch(await ActionCreator.getMedical(medicalId));
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    markNotified(medicalId) {
        return async (dispatch) => {
            try {
                await CallHelperService.medical.notified(medicalId);
                return dispatch(await ActionCreator.getMedical(medicalId));
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    missionDispatch({missionId, medicalIds}) {
        return async (dispatch) => {
            try {
                return await CallHelperService.mission.dispatch({missionId, medicalIds});
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    missionAssign({missionId, targetMedicalId}) {
        return async (dispatch) => {
            try {
                return await CallHelperService.mission.assign({missionId, targetMedicalId});
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    medicalChangeHospital({medicalId, hospitalId}) {
        return async (dispatch) => {
            try {
                await CallHelperService.medical.changeHospital({medicalId, hospitalId});
                return dispatch(ActionCreator.getMedical(medicalId));
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    updateUserAvatar({userId, base64_src, url}) {
        return async (dispatch) => {
            try {

                await CallHelperService.user.updateAvatar({userId, base64_src, url});


                const apiUser = await CallHelperService.user.findById(userId);

                const fuseUser = {
                    ...apiUser,
                    role: apiUser.role.label,
                    from: 'uecare-api',
                    uuid: apiUser.token,
                    data: {
                        displayName: apiUser.name,
                        email: apiUser.email,
                        photoURL: apiUser.avatar && apiUser.avatar.url
                    }
                };

                return dispatch(ReduxUser.ActionCreator.setUserData(fuseUser));

            } catch (error) {
                throw dispatch({error});
            }
        };
    },

};

const initialState = {
    medicals: [],
    medical: {},
};

const Reducer = function (state = initialState, action) {
    switch (action.type) {
        case Action.GET_MEDICAL:
            return {
                ...state,
                medical: action.medical
            };
        case Action.GET_MEDICALS:
            return {
                ...state,
                medicals: action.medicals
            };
        case Action.UPDATE_MEDICAL:
            return {
                ...state,
                medical: action.updatedMedical
            };
        default: {
            return state;
        }
    }
};

export default {Action, ActionCreator, Reducer};



// WEBPACK FOOTER //
// ./src/store/actionreducers/callHelper.js